module.exports = __webpack_public_path__ + "img/1-1.1贾平凹（作家）.49fba029.jpg";